import { Tabs } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Planning from "./Tabs/Planning";
import Progressive from "./Tabs/Progressive";
import { useFormik } from "formik";
import { buildQueryString, trimData } from "../../utils/utilities";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../../redux/ducks/Filters";
import { langDate } from "../../utils/properties";
import { get, toLower } from "lodash";
import Filter from "../../components/functional_components/Filter/Filter";
import dayjs from "dayjs";

const Lg = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentDate = dayjs().format("YYYY");
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));

  useEffect(() => {
    const queryString = buildQueryString({}, { year: currentDate });
    dispatch(setFilters(queryString));
  }, []);

  const formikFilter = useFormik({
    initialValues: {
      year: dayjs(currentDate, "YYYY"),
    },
    validate: (values) => {
      values = trimData(values);
      let errors = {};
      if (!values.year) errors.year = "Required!";
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      const queryString = buildQueryString({}, { year: dayjs(values.year, "YYYY").format("YYYY") });
      dispatch(setFilters(queryString));
    },
  });

  const fieldsFilter = [
    {
      type: "year",
      isRequired: true,
      id: "year",
      name: "year",
      format: "YYYY",
      locale: langDate[`locale_${toLower(currentLanguage)}`],
      label: t("projectEstimate.filter.year"),
      value: formikFilter.values.year,
      onChange: (date) => {
        formikFilter.setFieldValue("year", date);
      },
    },
  ];

  const resetFilter = () => {
    const queryString = buildQueryString({}, { year: currentDate });
    formikFilter.setFieldValue("year", dayjs(queryString.obj?.year, "YYYY"));
    dispatch(setFilters(queryString));
  };

  return (
    <>
      <Filter formikForm={formikFilter} fields={fieldsFilter} onReset={resetFilter} allInOneRow />
      <Tabs
        className="PFtabs"
        items={[
          {
            label: t(`lg.tabs.planning`),
            key: "planning",
            children: <Planning />,
          },
          {
            label: t(`lg.tabs.progressive`),
            key: "progressive",
            children: <Progressive />,
          },
        ]}
      />
    </>
  );
};

export default Lg;
